



























































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { data } from "@/embeddings/data";
import { vector } from "@/embeddings/vector";
import { knn } from "@/embeddings/knn";
import { wordcloud } from "@/wordcloud/wordcloud";
import {
  Word,
  Url,
  Controller,
  UrlResults,
  UrlResult
} from "@/domainproject/controller.ts";

import Filters from "@/components/Filters.vue";
import Scorer from "@/components/Scorer.vue";
import { Filter, FilterJson } from "@/domainproject/filter";
import { deserializeFilter } from "@/domainproject/filters/all";

const UPDATE_RATE = 0; // 300 millis

const hashCode = function(s: string){
  return s.split("").reduce(function(a,b){a=((a<<5)-a)+b.charCodeAt(0);return a&a},0);              
}

@Component({
  components: { Filters, Scorer }
})
export default class DataDisplay extends Vue {
  domainExtentionFilter: number = -1;

  urlsLoaded = false;
  embeddingsLoaded = false;
  $_controller: Controller | null = null;

  inputTimer: number | null = null;

  filteredUrls: UrlResults | null = null;

  refreshing = false;

  history: FilterJson[][] = [[]];
  historyPos = 1;

  numUrls = 0;

  exportIncludeAll = false;
  exportIncludeScores = false;
  exportOutputLines = 1000;

  lastUpdated = "loading...";

  exportUrls() {
    this.$modal.show("exportUrls");
  }

  updateInput(filters: Filter[], history = true) {
    this.refreshing = true;
    if (this.inputTimer != null) {
      clearTimeout(this.inputTimer);
      this.inputTimer = null;
    }
    this.inputTimer = setTimeout(() => {
      this.inputTimer = null;
      this.refreshDomains(filters, history);
    }, UPDATE_RATE);
  }

  updateHistory(filters: Filter[]) {
    // Remove later history
    this.history.splice(this.historyPos);
    this.history.push(filters.map(f => f.serialize()));
    this.historyPos = this.history.length;
  }

  undo() {
    if (this.historyPos <= 1) return;
    this.historyPos--;
    this.deserialize(this.history[this.historyPos - 1]);
  }

  redo() {
    if (this.historyPos >= this.history.length) return;
    this.historyPos++;
    this.deserialize(this.history[this.historyPos - 1]);
  }

  clear() {
    this.deserialize([], true);
  }

  get currentJson() {
    return this.history[this.historyPos - 1];
  }

  get empty(): boolean {
    return this.currentJson.length == 0;
  }

  save() {
    const contents = JSON.stringify(this.currentJson);
    const hiddenInput = this.$refs.copy as HTMLInputElement;
    hiddenInput.value = contents;
    hiddenInput.select();
    document.execCommand("copy");
    alert("Copied filter state: " + hiddenInput.value);
  }

  download() {
    if (this.$_controller == null) return;

    const limit = this.exportIncludeAll ? this.numUrls : this.exportOutputLines;
    const includeScores = this.exportIncludeScores;

    const urlResults = this.$_controller.filteredUrls(
      this.$_currentFilters,
      limit
    );
    let output = "";

    output += "URL";
    if (includeScores) {
      for (let i = 0; i < this.$_currentFilters.length; i++) {
        output += `,Filter ${i + 1}`;
      }
    }
    output += "\n";

    for (let i = 0; i < urlResults.$_results.length; i++) {
      const result = urlResults.$_results[i];
      output += result.$_url.$_text;
      if (includeScores) {
        for (let j = 0; j < result.$_filters.length; j++) {
          const score = result.$_filters[j].$_score;
          output += `,${score == null ? "" : score}`;
        }
      }
      output += "\n";
    }

    var a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(
      new Blob([output], { type: "text/csv" })
    );
    a.download = "export.csv";

    // Append anchor to body.
    document.body.appendChild(a);
    a.click();

    // Remove anchor from body
    document.body.removeChild(a);
  }

  load() {
    const contents = prompt("Paste in the filter state:") as string;
    this.deserialize(JSON.parse(contents) as FilterJson[], true);
  }

  deserialize(json: FilterJson[], history = false) {
    console.log("deserializing", json);
    const filters = [];
    for (let i = 0; i < json.length; i++) {
      filters.push(deserializeFilter(json[i]));
    }
    (this.$refs.filters as Filters).updateFilters(filters, false);
    this.updateInput(filters, history);
  }

  $_currentFilters: Filter[] = [];

  refreshDomains(filters: Filter[], history = true) {
    console.log("refreshing");
    if (history) this.updateHistory(filters);

    if (this.$_controller == null) {
      this.refreshing = false;
      return;
    }
    this.filteredUrls = this.$_controller.filteredUrls(filters);
    this.$_currentFilters = filters;
    this.refreshing = false;
  }

  forceInstant() {
    this.urlsLoaded = true;
    this.embeddingsLoaded = true;
  }

  async mounted() {
    const username = prompt('Please enter your username: ', '');
    const password = prompt('Please enter your password: ', '');
    const account = username + "/" + password;
    const hashedAccount = hashCode(account);
    if (hashedAccount !== 1311940304) {
      alert("Sorry! You don't have permission to access this page.");
      return;
    }

    const rndStr = '?t=' + (new Date()).getTime();
    // return this.forceInstant();
    // Pull words
    const latestResponse = await fetch(
      "https://grg-domainproject-output-new.s3-us-west-2.amazonaws.com/latest/latest_info.txt" + rndStr,
      { mode: "cors" }
    );
    const latest = (await latestResponse.text()).trim();

    // Pull date out
    const latestParts = latest.split("/");
    const latestDate = latestParts[latestParts.length - 1];
    const latestDateStr = latestDate
      .split("_")
      .slice(0, 2)
      .join(" ");
    const latestMoment = ((window as any).moment as any).utc(
      latestDateStr,
      "YYYY-MM-DD HH-mm-ss"
    );
    this.lastUpdated = latestMoment.toDate();

    const wordsResponse = await fetch(
      "https://grg-domainproject-output-new.s3-us-west-2.amazonaws.com/latest/words.txt" + rndStr
    );
    const rawWords = await wordsResponse.text();
    const splitChar = rawWords.includes("\r\n") ? "\r\n" : "\n";
    const words = rawWords.split(splitChar).filter(x => x.trim() != "");

    // Pull index
    const indexResponse = await fetch(
      'https://grg-domainproject-output-new.s3-us-west-2.amazonaws.com/latest/index.json' + rndStr
      // `https://storage.googleapis.com/${latest}/index.json`
    );
    const index = await indexResponse.json();
    const wordLengths = Object.keys(index)
      .map(x => parseInt(x))
      .sort((a, b) => a - b);

    // Pull URLs
    const urlsResponse = await fetch(
      'https://grg-domainproject-output-new.s3-us-west-2.amazonaws.com/latest/domains.bin' + rndStr
      // `https://storage.googleapis.com/${latest}/domains.bin`
    );
    const urlsBin = new Uint16Array(await urlsResponse.arrayBuffer());

    const urlsMetaDataResponse = await fetch(
      // '/domains_metadata.bin'
      'https://grg-domainproject-output-new.s3-us-west-2.amazonaws.com/latest/domains_metadata.bin' + rndStr
      // `https://storage.googleapis.com/${latest}/domains.bin`
    );
    const urlsMetaData = await urlsMetaDataResponse.text();

    const urls: Url[] = [];
    let currentLine: Word[] = [];
    let currentWordLength = wordLengths[0];
    let currentWordLengthIndex = 0;
    let nextWordLengthIndex =
      currentWordLengthIndex == wordLengths.length - 1
        ? null
        : index[wordLengths[currentWordLengthIndex + 1]];
    let urlIndex = 0;
    urlsBin.forEach((wordIndex, i) => {
      if (nextWordLengthIndex != null && i * 2 >= nextWordLengthIndex) {
        currentWordLengthIndex++;
        currentWordLength = wordLengths[currentWordLengthIndex];
        nextWordLengthIndex =
          currentWordLengthIndex == wordLengths.length - 1
            ? null
            : index[wordLengths[currentWordLengthIndex + 1]];
      }
      const word = new Word(words[wordIndex], wordIndex);
      currentLine.push(word);
      if (currentLine.length >= currentWordLength) {
        const record = urlsMetaData.slice(urlIndex*20, (urlIndex+1)*20);
        const checkingChar = record[0];
        let extIndex = 0;
        let price = 0;
        let linkId = '';
        let age = 0;
        let expired = false;
        if (checkingChar === '#') {
          extIndex = parseInt(record.slice(1,3));
          price = parseInt(record.slice(3,5));
          linkId = record.slice(5,17).replace(/\-/g, '');
          age = parseInt(record.slice(17,19));
          expired = parseInt(record.slice(19,20)) === 1 ? false : true;
        }
        const newUrl = new Url(currentLine, urlIndex++, extIndex, price, linkId, age, expired);
        urls.push(newUrl);
        // debug decoding
        // if (urlIndex < 100) {
        //   const u = newUrl;
        //   console.log(u.$_text, u.$_ext , u.$_price, u.$_linkId)
        // }
        currentLine = [];
      }
    });

    this.urlsLoaded = true;
    this.$forceUpdate();

    // Pull embeddings
    const embeddingsResponse = await fetch(
      "https://grg-domainproject-output-new.s3-us-west-2.amazonaws.com/latest/embeddings.bin" + rndStr
    );
    const embeddingsBin = new Float32Array(
      await embeddingsResponse.arrayBuffer()
    );

    const dataset = new data.DataSet(
      words.map((word, i) => {
        return {
          vector: embeddingsBin.slice(i * 100, (i + 1) * 100),
          metadata: {
            label: word
          },
          index: i,
          projections: {}
        };
      })
    );
    this.embeddingsLoaded = true;
    this.$_controller = new Controller(words, urls, dataset);
    this.numUrls = urls.length;
  }
}
